<template>
  <div>
    <div class="select-row select-row-first">
      <div class="row-select-item">
        <div
          style="display: flex; width: 100%; align-items: center; heigth: 100%"
        >
          <div style="white-space: nowrap" class="row-label">所在区域：</div>
          <a-cascader
            :options="citySource"
            @change="filterCity"
            v-model="city"
            changeOnSelect
            placeholder="请选择所在区域"
            class="row-item"
          />
        </div>
      </div>
      <div class="row-select-item">
        <div
          style="
            display: flex;
            width: 100%;
            align-items: center;
            heigth: 100%;
            justify-content: ;
          "
        >
          <div style="white-space: nowrap" class="row-label">网络状态：</div>
          <a-select
            placeholder="请选择"
            class="row-item"
            @change="handleSelectDevic"
            :value="filterParams.onlineStatus"
          >
            <a-select-option value="0" key="1">设备离线</a-select-option>
            <a-select-option value="1" key="2">设备在线</a-select-option>
            <a-select-option value="2" key="3">离线超时</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="row-select-item">
        <div
          style="
            display: flex;
            width: 100%;
            align-items: center;
            heigth: 100%;
            justify-content: ;
          "
        >
          <div style="white-space: nowrap" class="row-label">开放情况：</div>
          <a-select
            placeholder="请选择"
            class="row-item"
            @change="handleCanRelease"
            :value="filterParams.canRelease"
          >
            <a-select-option value="1" key="1">可接广告</a-select-option>
            <a-select-option value="0" key="2">不接广告</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="row-select-item">
        <a-button type="primary" html-type="submit" @click="handleSearch"
          >查询</a-button
        >
        <a-button :style="{ marginLeft: '8px' }" @click="handleReset"
          >重置</a-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../commomFun/api.js";
export default {
  props: {
    getAllSendList: Function,
  },
  data() {
    return {
      // 省市区下拉
      citySource: [],
      // 过滤参数
      filterParams: {
        areaCode: "",
        onlineStatus: "",
        canRelease: "",
      },
      city: [],
      modelType: [
        { text: "QLG19-C215", value: "7" },
        { text: "GWS19-49", value: "12" },
        { text: "QLL19-C32", value: "13" },
        { text: "QLG19-215", value: "14" },
        { text: "QLL19-32", value: "15" },
        { text: "QLG2020-R8", value: "17" },
      ],
    };
  },
  created() {
    this.getCityList();
  },
  methods: {
    // 城市模糊筛选
    filterCity(arr) {
      this.filterParams.areaCode = arr.length > 0 ? arr[arr.length - 1] : "";
    },
    handleSelectPub(val) {
      this.filterParams.publish = val;
    },
    handleSelectDown(val) {
      this.filterParams.down = val;
    },
    handleSelectDevic(val) {
      this.filterParams.onlineStatus = val;
    },
    handleCanRelease(val) {
      this.filterParams.canRelease = val;
    },
    handleSelectModal(val) {
      this.filterParams.deviceModel = val;
    },
    // 查询
    handleSearch() {
      this.current = 1;
      const filterParams = JSON.parse(JSON.stringify(this.filterParams));
      Object.keys(filterParams).forEach((key) => {
        if (!filterParams[key]) {
          delete filterParams[key];
        }
      });
      this.$emit("callback", filterParams);
    },
    // 获取城市选择
    getCityList() {
      api.getApi("/machine/getAreaList").then((res) => {
        if (res.data.code == 200) {
          let areaList = [];
          for (let firstKey of res.data.data) {
            let firstObj = {
              value: firstKey.key,
              label: firstKey.value,
              children: [],
            };
            for (let secondKey of firstKey.children) {
              let secondObj = {
                value: secondKey.key,
                label: secondKey.value,
                children: [],
              };
              for (let threeKey of secondKey.children) {
                secondObj.children.push({
                  value: threeKey.key,
                  label: threeKey.value,
                });
              }
              firstObj.children.push(secondObj);
            }
            areaList.push(firstObj);
          }

          this.citySource = areaList;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 重置 - 初始化数据
    handleReset() {
      let obj = {
        areaCode: "",
        onlineStatus: "",
        canRelease: "",
      };
      this.filterParams = obj;
      this.city = [];
      this.$emit("callback", {
        areaCode: null,
        onlineStatus: null,
        canRelease: null,
      });
    },
  },
};
</script>
<style lange="less" scoped>
.row-item {
  flex: 1;
  margin-bottom: 16px;
}
.row-label {
  width: 70px;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}
.ant-col-8 {
  height: 32px !important;
  margin-bottom: 16px !important;
}
.select-row {
  margin-top: 24px;
  height: 32px;
  display: flex;
  margin-bottom: 24px;
}
.select-row-first {
  margin-bottom: 16px;
}
.select-row-last {
  margin-top: 0px;
  margin-bottom: 24px;
  display: flex;
  justify-content: flex-start;
  padding-left: 24px;
}
.row-select-item {
  margin-right: 32px;
  width: 24%;
}
</style>